import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { ShopGoogleReviews as ShopGoogleReviewsTypes } from '@sbt-web/network/types';
import { Icon } from '@sbt-web/ui';
import { Stars } from './_components/Stars';
import styles from './index.module.scss';
interface Props {
  data: ShopGoogleReviewsTypes | null;
  classes?: Array<string>;
}
export const ShopGoogleReviews = t0 => {
  const $ = _c(21);
  const {
    data,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  if (!data?.shopId || !data?.rating || !data?.links?.placeUri) {
    return null;
  }
  const {
    rating,
    links
  } = data;
  const placeUri = links?.placeUri;
  let t3;
  if ($[2] !== classes) {
    t3 = cn(styles.container, classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== rating) {
    t4 = <span className={styles.points}>{rating}</span>;
    $[4] = rating;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data.rating) {
    t5 = <Stars score={data.rating} />;
    $[6] = data.rating;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== placeUri || $[9] !== t5) {
    t6 = <a href={placeUri} target="_blank" rel="noreferrer" aria-label="Visualizza le recensioni su Google">{t5}</a>;
    $[8] = placeUri;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon name="Google" classes={[styles.googleLogo]} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t6) {
    t8 = <div className={styles.rating}>{t4}{t6}{t7}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== placeUri) {
    t9 = <a href={placeUri} target="_blank" rel="noreferrer" className={styles.poweredby} aria-label="Visualizza le recensioni su Google">Punteggio su Google</a>;
    $[15] = placeUri;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className={t3}>{t8}{t9}</div>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};